import * as Yup from 'yup';

export default Yup.object().shape({
  rei: Yup.number().min(0),
  phi: Yup.number().min(0),
  cropid: Yup.string()
    .nullable()
    .required('You must select a crop')
});
